<div class="hold-transition login-page">
    
    <div class="col-12 centrado-boton" (click)="LoginUsuario($event)" >
        <a class="btn btn-block btn-success w-100" style="background-color: #AE201E !important;">
            Login<i class="fas fa-sign-in-alt ml-2"></i>
        </a>
    </div>
</div>